<script lang="ts">
    import EditorStore from "@src/model/Editor.Store";
    import MainStore from "@src/model/Main.Store";
    
    import { onDestroy, onMount } from "svelte";
    
        let trackElem: HTMLDivElement;
        let subscribeList: any[] = [];
   
        let trackText: string = '';
        onMount(() => {
            subscribeList.push(
                MainStore.getValue().currentVideoLength.subscribe((v) => {
                    let pxWidth = ((v || 0) / EditorStore.getSegmentLength()) * 100;
                    trackElem.style.setProperty('width', `${pxWidth}px`);
    
                }),
                EditorStore.getValue().currentTimelineSizingFactor.subscribe((v) => {
                    let pxWidth = ((MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength()) * 100;
                    trackElem.style.setProperty('width', `${pxWidth}px`);
                }),
                MainStore.getValue().currentVideoSource.subscribe((v) => {
                    console.log(v);
                    trackText = v;
                }),
            );
        });
        onDestroy(() => {
            subscribeList.forEach((v) => v());
        });
    </script>
    
    <div class="ivdemo-timeline-track" bind:this={trackElem}>
        {trackText}
    </div>
    
    
    <style>
        .ivdemo-timeline-track {
            background-color: #1f1f1f;
            /* border-bottom: 1px #9f9f9f solid; */
            border: 1px #9f9f9f solid;
            height: 16px;
            user-select: none;
            -webkit-user-select: none;
            width: 3000%;
            color: white;
            font-size: 0.8rem;
        }
    </style>
    
    